import { useEffect, useRef } from "react";

// Calls fn every `ms` while the tab is visible; refetches on focus / when the tab becomes visible.
export function usePoll(fn, ms = 45000, enabled = true) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    let iv = null;
    const run = () => { if (document.visibilityState === "visible") ref.current(); };
    const start = () => { clearInterval(iv); iv = setInterval(run, ms); };
    const onVis = () => { if (document.visibilityState === "visible") { run(); start(); } else clearInterval(iv); };
    start();
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", run);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); window.removeEventListener("focus", run); };
  }, [ms, enabled]);
}
